export default __webpack_public_path__ + "static/about-us-9bc186e53cda6e74351ecddbd0dcd628.jpg";